/**
 * Selectors used by multiple components/modules
 * eventually may be moved into redux selectors
 */

import { dateToString } from 'omni-ui';

// TODO: Move these selectors to whichever store/ducks/[duck].js makes sense
export function selectCampaignStartDate(campaign) {
  return campaign?.start_date;
}

export function selectCampaignEndDate(campaign) {
  return campaign?.end_date;
}

export function selectCampaignTimeFrameDisplay(campaign) {
  const startDateStr = selectCampaignStartDate(campaign);
  const endDateStr = selectCampaignEndDate(campaign);
  let startDateDisplay;
  let endDateDisplay;

  if (startDateStr) startDateDisplay = dateToString(new Date(startDateStr));
  if (endDateStr) endDateDisplay = dateToString(new Date(endDateStr));

  return `${startDateDisplay ?? '…'} - ${endDateDisplay ?? '…'}`;
}

export function selectSteps(step) {
  return step?.steps ?? step?.framework_template?.steps;
}

export function selectStepModules(step) {
  return step?.step_modules ?? step?.framework_template?.step_modules;
}

// TODO: Delete if unused in the future
export function selectStepLevelIndex(campaign, targetStep) {
  // clone array from selectSteps since we will mutate
  let level = [...selectSteps(campaign)];
  let nextLevel = [];
  let idx = -1;

  while (level.length) {
    const step = level.shift();
    idx += 1;
    if (step === targetStep) {
      break;
    } else {
      const children = selectSteps(step);
      if (children) {
        // clone array from selectSteps since we will mutate
        nextLevel = [...nextLevel, ...children];
      }
    }
    if (!level.length && nextLevel.length) {
      idx = -1;
      level = nextLevel;
      nextLevel = [];
    }
  }
  return idx;
}

export function selectCampaignStepId(step) {
  return step.uuid_campaign_step;
}

export function selectStepModuleId(stepModule) {
  return stepModule.module.uuid_module;
}
